import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Input, InputGroup, FormGroup, Form, Row, Col, Table } from 'reactstrap';
import { Translate, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { IDuAn } from 'app/shared/model/du-an.model';
import { searchEntities, getEntities } from './du-an.reducer';

export const DuAn = (props: RouteComponentProps<{ url: string }>) => {
  const dispatch = useAppDispatch();

  const [search, setSearch] = useState('');

  const duAnList = useAppSelector(state => state.duAn.entities);
  const loading = useAppSelector(state => state.duAn.loading);

  useEffect(() => {
    dispatch(getEntities({}));
  }, []);

  const startSearching = e => {
    if (search) {
      dispatch(searchEntities({ query: search }));
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const handleSyncList = () => {
    dispatch(getEntities({}));
  };

  const { match } = props;

  return (
    <div>
      <h2 id="du-an-heading" data-cy="DuAnHeading">
        <Translate contentKey="xtdtApp.duAn.home.title">Du Ans</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="xtdtApp.duAn.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to="/du-an/new" className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="xtdtApp.duAn.home.createLabel">Create new Du An</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('xtdtApp.duAn.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {duAnList && duAnList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th>
                  <Translate contentKey="xtdtApp.duAn.id">ID</Translate>
                </th>
                <th>
                  <Translate contentKey="xtdtApp.duAn.ten">Ten</Translate>
                </th>
                <th>
                  <Translate contentKey="xtdtApp.duAn.hinhAnhDuAn">Hinh Anh Du An</Translate>
                </th>
                <th>
                  <Translate contentKey="xtdtApp.duAn.diaDiem">Dia Diem</Translate>
                </th>
                <th>
                  <Translate contentKey="xtdtApp.duAn.dienTichCongSuat">Dien Tich Cong Suat</Translate>
                </th>
                <th>
                  <Translate contentKey="xtdtApp.duAn.viTriDiaLy">Vi Tri Dia Ly</Translate>
                </th>
                <th>
                  <Translate contentKey="xtdtApp.duAn.mucTieu">Muc Tieu</Translate>
                </th>
                <th>
                  <Translate contentKey="xtdtApp.duAn.hinhAnhMucTieu">Hinh Anh Muc Tieu</Translate>
                </th>
                <th>
                  <Translate contentKey="xtdtApp.duAn.hienTrangSuDungDat">Hien Trang Su Dung Dat</Translate>
                </th>
                <th>
                  <Translate contentKey="xtdtApp.duAn.danCu">Dan Cu</Translate>
                </th>
                <th>
                  <Translate contentKey="xtdtApp.duAn.loiTheDauTu">Loi The Dau Tu</Translate>
                </th>
                <th>
                  <Translate contentKey="xtdtApp.duAn.suPhuHopVoiHoSoQuyHoach">Su Phu Hop Voi Ho So Quy Hoach</Translate>
                </th>
                <th>
                  <Translate contentKey="xtdtApp.duAn.hieuQua">Hieu Qua</Translate>
                </th>
                <th>
                  <Translate contentKey="xtdtApp.duAn.ghiChu">Ghi Chu</Translate>
                </th>
                <th>
                  <Translate contentKey="xtdtApp.duAn.hinhAnhSoDoViTri">Hinh Anh So Do Vi Tri</Translate>
                </th>
                <th>
                  <Translate contentKey="xtdtApp.duAn.geometry">Geometry</Translate>
                </th>
                <th>
                  <Translate contentKey="xtdtApp.duAn.diaPhuong">Dia Phuong</Translate>
                </th>
                <th>
                  <Translate contentKey="xtdtApp.duAn.linhVuc">Linh Vuc</Translate>
                </th>
                <th>
                  <Translate contentKey="xtdtApp.duAn.loaiDuAn">Loai Du An</Translate>
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {duAnList.map((duAn, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/du-an/${duAn.id}`} color="link" size="sm">
                      {duAn.id}
                    </Button>
                  </td>
                  <td>{duAn.ten}</td>
                  <td>{duAn.hinhAnhDuAn}</td>
                  <td>{duAn.diaDiem}</td>
                  <td>{duAn.dienTichCongSuat}</td>
                  <td>{duAn.viTriDiaLy}</td>
                  <td>{duAn.mucTieu}</td>
                  <td>{duAn.hinhAnhMucTieu}</td>
                  <td>{duAn.hienTrangSuDungDat}</td>
                  <td>{duAn.danCu}</td>
                  <td>{duAn.loiTheDauTu}</td>
                  <td>{duAn.suPhuHopVoiHoSoQuyHoach}</td>
                  <td>{duAn.hieuQua}</td>
                  <td>{duAn.ghiChu}</td>
                  <td>{duAn.hinhAnhSoDoViTri}</td>
                  <td>{duAn.geometry}</td>
                  <td>{duAn.diaPhuong ? <Link to={`/don-vi-hanh-chinh/${duAn.diaPhuong.id}`}>{duAn.diaPhuong.id}</Link> : ''}</td>
                  <td>{duAn.linhVuc ? <Link to={`/linh-vuc/${duAn.linhVuc.id}`}>{duAn.linhVuc.id}</Link> : ''}</td>
                  <td>{duAn.loaiDuAn ? <Link to={`/loai-du-an/${duAn.loaiDuAn.id}`}>{duAn.loaiDuAn.id}</Link> : ''}</td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`/du-an/${duAn.id}`} color="info" size="sm" data-cy="entityDetailsButton">
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button tag={Link} to={`/du-an/${duAn.id}/edit`} color="primary" size="sm" data-cy="entityEditButton">
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button tag={Link} to={`/du-an/${duAn.id}/delete`} color="danger" size="sm" data-cy="entityDeleteButton">
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="xtdtApp.duAn.home.notFound">No Du Ans found</Translate>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default DuAn;
